import React from 'react';
import { Stack } from '@mui/material';
import { Link } from 'react-router-dom';

import logo from '../assets/logo.png';
import Searchbar from './Searchbar';

const Navbar = () => (
    <Stack direction="row" 
      alignItems="center" 
      p={2} 
      sx={{ position: 'sticky', background: '#0D0E0E', top: 0, justifyContent: 'space-between'}}
    >
      <Link to='/' style={{ display: 'flex', alignItems: 'center' }}>
        <img src={logo} alt="Logo" height={45}/>
      </Link>
      <Searchbar />
    </Stack>
  )


export default Navbar